import MarkingInput from './MarkingVariants/MarkingInput';
import MarkingMenu from './MarkingVariants/MarkingMenu';
import MarkingAttachment from './MarkingVariants/MarkingAttachment';
import { memo } from 'react';

const componentMap = {
  time: MarkingInput,
  date: MarkingInput,
  longanswer: MarkingInput,
  shortanswer: MarkingInput,
  multiplechoice: MarkingMenu,
  singlechoice: MarkingMenu,
  attachment: MarkingAttachment
};

const MarkingContent = ({ question, record, assessmentId, onChangeAlert, disabled }) => {
  const { type } = question;
  const MarkingComponent = componentMap[type?.value] || (() => null); // Default to null if no match

  return (
    <MarkingComponent
      id={`making-type-${
        type?.value === 'multiplechoice' || type?.value === 'singlechoice' ? 'menu' : 'input'
      }`}
      question={question}
      record={record}
      onChangeAlert={onChangeAlert}
      assessmentId={assessmentId}
      disabled={disabled}
    />
  );
};

const MemoizedMarkingContent = memo(MarkingContent);

const EditMarking = ({ question, record, assessmentId, onChangeAlert, disabled }) => (
  <MemoizedMarkingContent
    question={question}
    record={record}
    assessmentId={assessmentId}
    onChangeAlert={onChangeAlert}
    disabled={disabled}
  />
);

export default EditMarking;
